// extracted by mini-css-extract-plugin
module.exports = {"container":"_1YDZTY4O7U3-tF9q4H-mXx","visible":"VkhMwsDOeAbCE-OsBCp1Z","cancelBtn":"_2YqCFg8gxiOJdeKThRR34n","icon":"q7JRwcAUs9FxqcwNHfEB7","saveBtn":"rO0xNzNzZe70qg9SLPeoK"};